/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Reason_Low_UsageInputs */

const en_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not using it enough`)
};

const de_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze es nicht genug`)
};

const fr_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je ne l'utilise pas assez`)
};

const es_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lo uso lo suficiente`)
};

const it_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non lo uso abbastanza`)
};

const nl_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik het niet genoeg`)
};

const pl_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie uzywam wystarczajaco`)
};

const fi_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En kayta tarpeeksi`)
};

const da_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruger det ikke nok`)
};

const sv_cancel_reason_low_usage = /** @type {(inputs: Cancel_Reason_Low_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Använder det inte tillräckligt`)
};

/**
* | output |
* | --- |
* | "Not using it enough" |
*
* @param {Cancel_Reason_Low_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_reason_low_usage = /** @type {((inputs?: Cancel_Reason_Low_UsageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Reason_Low_UsageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_reason_low_usage(inputs)
	if (locale === "fr") return fr_cancel_reason_low_usage(inputs)
	if (locale === "es") return es_cancel_reason_low_usage(inputs)
	if (locale === "it") return it_cancel_reason_low_usage(inputs)
	if (locale === "nl") return nl_cancel_reason_low_usage(inputs)
	if (locale === "pl") return pl_cancel_reason_low_usage(inputs)
	if (locale === "fi") return fi_cancel_reason_low_usage(inputs)
	if (locale === "da") return da_cancel_reason_low_usage(inputs)
	if (locale === "sv") return sv_cancel_reason_low_usage(inputs)
	return en_cancel_reason_low_usage(inputs)
});